export default "__VITE_ASSET__CFyDTwOa__"